<template>
<div class="about container">
  <div class="row">
    <div class="col-12 col-4-md">
      <p class="about__intro">
        Thank You For Clapping is a creative design and development studio established in 2016. Comprising a diverse group of people with backgrounds in design, business strategy, product development, programming and creative direction, the idea behind our collective is to gather the best, creative and strategic minds to work and collaborate on design and technology-centric projects and startups.
      </p>
      <p class="about__text">
        And, despite the fact that futurist, inventor and engineer Ray Kurzweil has predicted the imminent arrival of a sentient, artificial intelligence, we’re currently at a stage where technology is lifeless, inanimate, dead. This means that Siri would probably make a crappy date, even if she sometimes displays an uncanny ability for snark and that your state-of the-art vacuum cleaner won’t heart your Instagram updates even though it lovingly caresses the nooks and crannies of your living room with the affectionate determination of a seasoned housewife. Still, that doesn’t mean we can’t treat machines like they have feelings. Which some of us tend to do even when it comes to useless artifacts like broken, ageing record players.
      </p>
      <p class="about__text">
        That’s because there’s poetry, emotion and subjectivity in obsolete technology. As William Gibson, the literary God of tech and sci-fi, wrote in a piece for Rolling Stone Magazine way back in 1989:
      </p>
      <p class="about__text">
        &raquo;I knew a man whose teen years had been L.A., jazz, the forties. He spoke of afternoons he’d spent, utterly transported, playing 78rpm recordings, “worn down white”, with repeated applications of a sharp steel stylus. That is, the shellac that carried the grooves on these originally black records was plain gone; that man heard that music.&laquo;
      </p>
    </div>
    <div class="col-12 col-8-md about__second">
      <img src="/static/images/office-large@2x.jpg" class="responsive-image" alt="Thank You For Clapping Office">
      <div class="flex">
        <div class="about__text-container">
          <p class="about__text">
            The love between a man and his ageing machine: slightly perverse yet totally legitimate and ultimately deeply human. So human, in fact, that numerous cultural movements were founded on similar sentiments. Where would electronic music, for example, be without a generous helping of machine fetishism?
          </p>
          <p class="about__text">
            At this very moment in time, exceptionally smart and gifted engineers, scientist and other venerable nerds are doing their utmost to make the most amazing gadgets the world has ever seen. Things are moving at an incredible pace and trying to keep up with all that unrelenting innovation can, at times, be a little daunting. Your phone communicates with a satellite that hurtles around the Earth. You have more power crammed into your iPad than what a computer the size of a small house could muster in 1971. Not only do they perform well, they look incredible. Out of this world to the point where you intermittently catch yourself pondering the scientific viability of time travel.
          </p>
          <p class="about__text">
            What’s more, you get the distinct feeling that the ideation and production behind these feats of engineering weren’t just motivated by profit. Don’t you think the creators want to make other people feel what they feel? Ultimately, it must be about reaching out to other people. Products that are only in it for the money are on the whole uninspiring and tedious. And this is far from being the case with the new breed of gadgets; they make you want to touch them, interact with them and, let’s face it, have them near you at all times, so that you can really, truly feel what comes out of them.
          </p>
          <p class="about__text">
            The love between humans and their machines: worrying, infantile, twisted. And isn’t that’s precisely what makes it deeply and utterly human?
          </p>
          <p class="about__text">
            Machines may not have feelings, but they do a pretty good job of making us feel.
          </p>
        </div>
        <div class="about__text-container">
          <p class="about__text about__text--larger fw-700">
            We’re a passionate bunch. More specifically, we’ve experienced first-hand what it takes to capture people’s attention and go from newly conceived idea to market-ready commercialization.
          </p>  
          <p class="about__text about__text--larger fw-700">
            In every project we engage ourselves in, the approach and execution is based on our comprehensive experience working at the intersection of technology, commerce, design and communication.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'about'
}
</script>

<style lang="sass" scoped>

@import "../assets/sass/utilities/variables"
@import "../assets/sass/utilities/mixins"

.about
  font-weight: 500
  letter-spacing: 0
  line-height: 1.4
  padding-bottom: 50px
  margin-top: 100px
  +medium
    padding-bottom: 75px
    margin-top: 200px

.about__intro
  font-size: 1.2rem
  margin-top: 0
  margin-bottom: 2.5rem
  font-weight: 700
  line-height: 1.3

.about__text
  margin-top: 15px
  margin-bottom: 15px
  font-size: 0.9rem
  &--larger
    margin-bottom: 1rem
    font-size: 1.2rem
    line-height: 1.3
  
.about__text-container
  width: 100%
  +medium
    width: 49%

.flex
  width: 100%
  flex-direction: column
  +medium
    justify-content: space-between
    flex-direction: row

.about__second
  .col-12
    +medium(max)
      margin-left: 0
      margin-right: 0
      width: 100%

</style>



// WEBPACK FOOTER //
// About.vue?3c9828ac